import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { Icon, ICONS } from "../Icons";

export const Button = styled("button")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  fontSize: "16px",
  fontWeight: 600,
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
  border: "none",
  backgroundColor: "#ffffff",
  cursor: "pointer",
  padding: "0",
  outline: "none",
  "&[disabled]": {
    opacity: "0.5"
  },
  [theme.breakpoints.only("xs")]: {
    top: "80px",
    right: "12px"
  }
}));

export const RemoveButton = ({ className = "", ...rest }) => (
  <Button className={className} type="button" {...rest}>
    <Icon name={ICONS.delete} alt="delete icon" />
  </Button>
);

/**
 * PropTypes for RemoveButton component
 */
RemoveButton.propTypes = {
  /**
   * Additional class name for styling
   */
  className: PropTypes.string,

  /**
   * Optional click handler
   */
  onClick: PropTypes.func,

  /**
   * Disabled state of the button
   */
  disabled: PropTypes.bool
};
